import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  useImFieldContextId,
  useImFieldContextTestId,
  useImStringField,
} from '@insurancemenu/imenu-components-lib/dist/components/imForm/IMForm/useIMFormContext';
import { IMInputSize } from '@insurancemenu/imenu-components-lib/dist/components/imForm/sharedStylings';
import { EffectiveDateConfigItem } from 'store/modules/initiate-quote/types';
import { TaggedSelectOptionType } from 'components/common/form/TaggedSelect/types';
import StageTag from 'components/common/enrollment/StageTag';
import { TaggedSelectStyled } from './styles';

export interface IMEffectiveDateSelectProps {
  name: string;
  options: EffectiveDateConfigItem[];
  label?: string;
  placeholder?: string;
  size?: IMInputSize;
  hideOnDisabled?: boolean;
  className?: string;
}

const mapEffectiveDateOptions = (options: EffectiveDateConfigItem[]): TaggedSelectOptionType[] =>
  options.map((option) => ({
    value: option.value,
    label: option.label,
    disabled: option.isDisabled,
    tag: option.stage ? <StageTag stage={option.stage} /> : null,
  }));

// TO-DO: Add an ability to pass right-side content to SwissSelectOption & remove focus from disabled options in IMSwissSelect.
// Then delete this component.

const IMEffectiveDateSelect: React.FC<IMEffectiveDateSelectProps> = observer(
  ({ name, size, hideOnDisabled, options, ...rest }: IMEffectiveDateSelectProps) => {
    const fieldControl = useImStringField(name);
    const id = useImFieldContextId(name);
    const testId = useImFieldContextTestId(name);

    return (
      !(fieldControl.disabled && hideOnDisabled) && (
        <TaggedSelectStyled
          value={fieldControl.value}
          id={id}
          onChange={(value): void => fieldControl.overrideValue(value)}
          validationPassed={!fieldControl.unpassedValidationMsg}
          validationMessage={fieldControl.unpassedValidationMsg || ''}
          disabled={fieldControl.disabled}
          data-test-id={testId}
          options={mapEffectiveDateOptions(options)}
          $size={size ?? 'full'}
          {...rest}
        />
      )
    );
  },
);

export default IMEffectiveDateSelect;
